import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const driverStatusesAdapter = getAdapter();

const driverStatusesSlice = createSlice({
  name: 'driverStatuses',
  initialState: driverStatusesAdapter.getInitialState(),
  reducers: {
    setDriverStatuses: (state, { payload: { driverStatuses } }) => {
      driverStatusesAdapter.setAll(state, driverStatuses);
    },
  },
});

const selectors = driverStatusesAdapter.getSelectors(({ driverStatuses }) => driverStatuses);

export const getDriverStatusesIncludingDeleted = (state) => selectors.selectAll(state);

export const getDriverStatuses = (state) => getDriverStatusesIncludingDeleted(state).filter(({ deleted }) => !deleted);

export const { setDriverStatuses } = driverStatusesSlice.actions;

export default driverStatusesSlice.reducer;
